export default {
  title: 'Note importante',
  buttons: {
    add_note: 'Adaugă notă',
  },
};
